document.querySelectorAll('.ibb025-tabs-nav').forEach(function(tabContainer) {
    // Find all links within the tab container
    const links = Array.from(tabContainer.querySelectorAll('.ibb025-tab-link'));
    let activeTab = links.find(link => link.getAttribute('href') === location.hash) || links[0];
    let activeContent = document.querySelector(`.ibb025-content-container[data-ibb025-tab="${activeTab.parentElement.dataset.ibb025Tab}"]`);

    // Set initial active tab and hide other contents
    activeTab.classList.add('active');
    document.querySelectorAll('.ibb025-content-container').forEach(content => {
        if (content !== activeContent) content.style.display = 'none';
    });

    // Handle mouseover for tab switching
    tabContainer.addEventListener('mouseover', function(event) {
        if (event.target.classList.contains('ibb025-tab-link')) {
            const newTab = event.target;
            const newContent = document.querySelector(`.ibb025-content-container[data-ibb025-tab="${newTab.parentElement.dataset.ibb025Tab}"]`);
            
            if (newTab !== activeTab) {
                // Update tab state
                activeTab.classList.remove('active');
                if (activeContent) activeContent.style.display = 'none';

                activeTab = newTab;
                activeContent = newContent;

                activeTab.classList.add('active');
                if (activeContent) activeContent.style.display = '';
            }
            event.preventDefault();
        }
    });
});